"use client"
import React from 'react'
import { useContext } from 'react'
import { AppContext } from '../context/AppContext'
import { GameContext } from '../context/GameContext';
// import { useNavigate } from 'react-router-dom';
import { useRouter } from 'next/navigation';

const FreeSpinModal = () => {
  // const navigate = useNavigate();
  const router = useRouter();
  const {
    freeSpinGame
  } = useContext(AppContext);
  const {
    startGame
  } = useContext(GameContext);

  const play = () => {
    // startGame(freeSpinGame?.gameId, freeSpinGame?.machineId, freeSpinGame?.displayName, () => navigate('games/' + freeSpinGame?.categoryIds[0]));
    startGame(freeSpinGame?.gameId, freeSpinGame?.machineId, freeSpinGame?.displayName, () => router.push('games/' + freeSpinGame?.categoryIds[0]));
    document.getElementById('idFreeSpin').style.display='none';
  }

  const close = () => {
    document.getElementById('idFreeSpin').style.display='none';
  }

  return (
    <div id="idFreeSpin" className="modal">
      <form className="modal-content">
        <div style={{display: 'flex', justifyContent: 'end'}}>
          <button type='button' onClick={close} className="BtnCloseModal"></button>
        </div>
      
        <div className="container">
          <h1>You have {freeSpinGame?.remainingSpins} free spins!</h1>
          <h3 style={{ marginBottom: 30 }}>{freeSpinGame?.displayName}</h3>
            <div className="ImageContainer">
              <img src={freeSpinGame?.gameImageUrl} alt="" />
            </div>

          <div className="RowContBntsCCP" style={{justifyContent: 'center'}}>
            <div className="Btns BtnDeposit" onClick={play}>
              Play
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default FreeSpinModal